import { AutoCompleteVirtualize } from '@openx/components-core/lib/AutoComplete/AutoCompleteVirtualize.tsx';
import type { RenderOptions } from '@openx/components-core/lib/AutoComplete/types.ts';
import type { AudienceMap } from '@openx/types/targeting/audience.ts';
import { produceSortedOptionsKeys } from '@openx/utils/lib/sortedOptions.ts';
import { useMemo } from 'react';

interface Props {
  label?: string;
  value: string;
  placeholder: string;
  onChange: (val: string) => void;
  options?: AudienceMap;
  isLoading: boolean;
  renderOptions?: RenderOptions<string>;
}

export const SegmentsDropdown = ({
  value,
  placeholder,
  options,
  isLoading,
  label,
  renderOptions = {},
  onChange,
}: Props) => {
  const optionsList = useMemo(() => produceSortedOptionsKeys(options), [options]);

  return (
    <AutoCompleteVirtualize
      textFieldProps={{ label, placeholder }}
      options={optionsList}
      fullWidth
      loading={isLoading}
      renderOptions={{
        dataTest: 'type-option',
        tooltip: true,
        ...renderOptions,
      }}
      getOptionLabel={option => options?.[option]?.name || option}
      onChange={(_e, value) => (value ? onChange(value) : onChange(''))}
      value={isLoading ? '' : value}
      disableClearable
      data-test="audience-segments-input"
    />
  );
};
